module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ana"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ANATOMY OF A BURGER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/bur"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BURGER PRIMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ESSENTIALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Dill Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ketchup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Yellow Mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Milkshakes & Malts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sautéed Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap01#page28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onions Three Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BURGERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page32a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4a.jpg"
    }
  }), _vm._v("  MEAT & POULTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caprese Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gorgonzola-Stuffed Burgers with Grilled Nectarines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Beef Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brie-Stuffed Burgers with Sage Onions on Foccacia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLAT Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teriyaki Sliders with Grilled Pineapple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Banh Mi Burgers with Pickled Vegetables & Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiced Lamb Sliders with Romesco Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb & Feta Burgers with Sumac-Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buffalo Burgers with Pimento Cheese & Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Burgers with Cheddar, Sautéed Onions & Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Chile Avocado Turkey Cheeseburgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Burgers with Bourbon BBQ Sauce & Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meatball Sliders with Provolone & Peperoncini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open-Face Chicken & Spinach Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page63a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4.jpg"
    }
  }), _vm._v("  SEAFOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Burgers with Herbed Aioli & Frisée Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrimp Po’Boy Sliders with Rémoulade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab Burgers with Smashed Avocado")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon Burgers with Green Goddess Dressing & Watercress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saigon Salmon Burgers with Carrot-Daikon Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Burgers Pan Bagnat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cod Burgers with Tartar Sauce & Lemony Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scallop Burgers with Lemony Butter-Caper Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page78a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p4b.jpg"
    }
  }), _vm._v("  VEGETARIAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Bean Bruschetta Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot-Farro Burgers with Curry Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artichoke-Spinach Burgers with Tomato-Feta Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mushroom-Lentil Burgers with Gruyère & Arugula")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falafel Burgers with Tahini-Cilantro Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Corn & Red Pepper Fritter Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portobello Burgers with Herbed Chèvre & Grilled Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant Burgers with Tomato-Ginger Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samosa Burgers with Spicy Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miso Tofu Burgers with Sautéed Chard & Asian Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa Burgers with Roasted Vegetables & Garlic Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#page97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini & Ricotta Burgers with Herbed Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SIDES & SALADS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bistro Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempura Onion Rings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salt & Vinegar Wedge Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Arugula & Herb Salad with Grilled Figs & Halloumi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israeli Couscous with Kale & Butternut Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Vegetable Skewers with Parmesan Dusting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibb Lettuce Salad with Grilled Peaches & Prosciutto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Fingerling Potato Salad with Tarragon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Gems with Blue Cheese Dressing & Tiny Croutons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fennel, Apple & Toasted Walnut Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chopped Salad with Grilled Corn & Cotija")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/menus",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MENUS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INDEX")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0